import { SellerService } from "../../domain/entities/SellerService"
import { ServiceEventType } from "../../domain/enum/serviceEventType.enum"
import { ServiceStatus } from "../../domain/enum/serviceStatus.enum"

interface ContructorParams {
	contact: string
	contact_telf: string
	email: string
	id: number
	name: string
	title: string
	weight: number
	status: ServiceStatus
	crossSelling: boolean
	clusters: { clusterId: number; clusterName: string }[]
	isTournament: boolean
	finishTournamentDate: Date
	availableTournamentPlaces: number
	eventType: ServiceEventType
	googleMapsUrl: string
	participants: number
	endDateTime: Date
}

export class SellerServicesModel {
	public contact: string
	public contact_telf: string
	public email: string
	public id: number
	public weight: number
	public name: string
	public title: string
	public status: ServiceStatus
	public crossSelling: boolean
	public clusters: { clusterId: number; clusterName: string }[]
	public isTournament: boolean
	public finishTournamentDate: Date
	public availableTournamentPlaces: number
	public googleMapsUrl: string
	public eventType: ServiceEventType
	public participants: number
	public endDateTime: Date

	constructor(params: ContructorParams) {
		this.contact = params.contact
		this.contact_telf = params.contact_telf
		this.email = params.email
		this.id = params.id
		this.name = params.name
		this.title = params.title
		this.weight = params.weight
		this.status = params.status
		this.crossSelling = params.crossSelling
		this.clusters = params.clusters
		this.isTournament = params.isTournament
		this.finishTournamentDate = params.finishTournamentDate
		this.availableTournamentPlaces = params.availableTournamentPlaces
		this.googleMapsUrl = params.googleMapsUrl
		this.eventType = params.eventType
		this.participants = params.participants
		this.endDateTime = params.endDateTime
	}

	static fromRawJson = (rawJson: any): SellerServicesModel => {
		const {
			id,
			email,
			contact_telf,
			name,
			title,
			contact,
			weight,
			status,
			crossSelling,
			clusters,
			isTournament,
			finishTournamentDate,
			availableTournamentPlaces,
			googleMapsUrl,
			eventType,
			endDateTime,
			participants
		} = rawJson
		return new SellerServicesModel({
			id,
			email,
			contact_telf,
			name,
			title,
			weight,
			contact,
			status,
			crossSelling,
			clusters,
			isTournament,
			finishTournamentDate,
			availableTournamentPlaces,
			googleMapsUrl,
			eventType,
			participants,
			endDateTime
		})
	}

	static fromDomain = (service: SellerService): SellerServicesModel => {
		return new SellerServicesModel({
			...service,
			contact: service.contact,
			contact_telf: service.contact_telf,
			email: service.email,
			id: service.id,
			name: service.name,
			title: service.title
		})
	}
}

declare module "./SellerServicesModel" {
	interface SellerServicesModel {
		toDomain(): SellerService
	}
}

SellerServicesModel.prototype.toDomain = function (): SellerService {
	const data = this
	return new SellerService({
		...data,
		contact: data.contact,
		contact_telf: data.contact_telf,
		email: data.email,
		id: data.id,
		name: data.name,
		weight: data.weight,
		title: data.title
	})
}
